var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FinishTime',{attrs:{"time":_vm.time,"bonus-seconds":_vm.bonusSeconds}}),(_vm.inValidTime)?[_vm._v(" "+_vm._s(_vm.displayStatus)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }